var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rectangle",style:(_vm.styles)},[_vm._v(_vm._s(_vm.instanceData.content))])
}
var staticRenderFns = []

export { render, staticRenderFns }